import React from "react";
import { motion } from "framer-motion";
import clg from "functions/log";

export const FeatureItem = ({title, iconClass, featureItemClass, featureItemTitleTagType = "span", type = "for-real-data", data, boxFeatureClass, dataTagAdditionalClass = "", hasRealDataWithIcon = false }) => {

    //clg("FeatureItem title: ", title)

    const formatData = (data) => {
        if( data && data.hasOwnProperty("postfix") ) {
            return (
                <>
                    {data.value}

                    {
                        (() => {
                            if( data.postfix === "m2" ) {
                                return (
                                    <span className="postfix">
                                        m<sup>2</sup>
                                    </span>
                                    
                                )

                            } else {
                                return(
                                    <span className="postfix">{data.postfix}</span>
                                ) 
                            }
                        })()
                    }
                </>
            )
        }
        return data.value
    }

    const renderBoxContent = () => {
        switch (type) {
            //Ha "valós adat" megjelenítésére van használva. pl: lakáshoz tartozó adatok: szobák száma, alapterület...
            case "for-real-data":
                return(
                    <>
                    {
                        !hasRealDataWithIcon ?
                        <span className={`real-data ${dataTagAdditionalClass}`}>{ formatData(data) }</span>
                        :
                        <>
                        <div className="row has-real-data-with-icon">
                            <div className="icon-container">
                                <span className={"c-icon " + iconClass + " " + dataTagAdditionalClass}></span>
                            </div>
                            <div className="real-data-container">
                                <span className={`real-data ${dataTagAdditionalClass}`}>{ formatData(data) }</span>
                                <span>{ title }</span>
                            </div>
                        </div>
                        
                        </>
                    }
                    </>
                )
            //Ha "dekorációként" van használva. pl: index 4db box
            case "for-decoration":
                return(
                    <span className={"c-icon " + iconClass + " " + dataTagAdditionalClass}></span>
                )
            default:
                return;
        }
    }

    return(
        <div className={ featureItemClass ? featureItemClass : "col-6 col-lg-3" }>
            <motion.div className={"box-feature" + ( boxFeatureClass ? " " + boxFeatureClass : "" )}
            whileHover={{
                scale : 1.05
            }}>
                
                { renderBoxContent() }

                { !hasRealDataWithIcon && (
                    React.createElement(
                        `${featureItemTitleTagType}`,
                        {className: "feature-title"},
                        title
                    )
                )}
 
            </motion.div>
        </div>
    )
}


//    @example
//    <Features featureItemClass="col-4 single-feature" boxFeatureClass="no-shadow apartment-data" data={
//    [
//        { title : "Emelet", data : { value: formatFloor(floor) }, dataTagAdditionalClass : "floor-" + floor  },
//        { title : "Alapterület", data : { value : floor_area, postfix: "m2"},  },
//        { title : "Szobák", data : { value: rooms } },
//    ]}
//    />

const Features = ({data, featureItemClass, featureItemTitleTagType, boxFeatureClass, parentClass = null, rowClass = null, type = "for-real-data" }) => {
    return(
        <div className={"features-1" + ( parentClass ? " " + parentClass : "" )}>
            <div className="container">
                <div className={`row${(rowClass ? ` ${rowClass}` : "")}`}>
                    {
                        data.map((curr, index) => (
                            <FeatureItem
                                title={curr.title}
                                iconClass={curr.iconClass} 
                                featureItemClass={featureItemClass}
                                boxFeatureClass={boxFeatureClass} 
                                featureItemTitleTagType={featureItemTitleTagType}
                                type={type}
                                data={curr.data}
                                dataTagAdditionalClass={curr.dataTagAdditionalClass}
                                hasRealDataWithIcon={curr.hasRealDataWithIcon}
                                key={"feature-item-" + index}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Features;